/* eslint-disable prettier/prettier */
/* eslint-disable */

export default {
  defaultProps: {
    disableRipple: false,
  },
};
